import { CopyableContent } from "@/src/components/copyable-content";
import { ValerieCardColSpan, ValerieCardField } from "@/src/components/valerie-card";
import { useComparison } from "@/src/context/comparison-text";
import { getDisplayValue, compareStrings, FieldType } from "@/src/lib/utils/string-utils";

interface ComparisonFieldProps {
  label: string;
  value: string;
  secondaryValue: string;
  type?: FieldType;
  compareAgainstTitle?: string;
  colSpan?: ValerieCardColSpan;
  startsRow?: boolean;
}

export function ComparisonField({
  label,
  value,
  secondaryValue,
  type = "text",
  compareAgainstTitle = "EMR",
  colSpan,
  startsRow,
}: ComparisonFieldProps) {
  const context = useComparison();

  if (context?.comparisonLabel) {
    compareAgainstTitle = context.comparisonLabel;
  }

  // Format values for display using centralized helper
  const formattedValue = getDisplayValue(value, type);
  const formattedSecondaryValue = getDisplayValue(secondaryValue, type);

  // Use raw values for comparison logic
  const hasConflict = !compareStrings(value, secondaryValue, type);

  return (
    <ValerieCardField label={label} colSpan={colSpan} startsRow={startsRow}>
      <CopyableContent text={formattedValue} textClassName={`${hasConflict ? "bg-warn/20" : "text-foreground"}`} />
      {hasConflict && (
        <div className="text-xs text-muted-foreground mt-1">
          <span className="text-warn dark:text-warn">
            {compareAgainstTitle}:{" "}
            <CopyableContent text={formattedSecondaryValue} textClassName="text-warn dark:text-warn" />
          </span>
        </div>
      )}
    </ValerieCardField>
  );
}
